import GET_BUYING_SESSION_GROUP from './getBuyingSessionGroup.graphql'

export default GET_BUYING_SESSION_GROUP
